import { render, staticRenderFns } from "./ProfileLatestPhotos.vue?vue&type=template&id=2219b2cd&"
import script from "./ProfileLatestPhotos.vue?vue&type=script&lang=js&"
export * from "./ProfileLatestPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports